/* eslint-disable no-console */

// Enregistrement conditionnel du service worker
// Note: Le service worker n'est enregistré qu'en production
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  // Utiliser un import dynamique pour éviter les erreurs de build
  import('register-service-worker').then((module) => {
    const { register } = module;
    
    register(`${process.env.BASE_URL}service-worker.js`, {
      ready() {
        console.log(
          'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
        )
      },
      registered() {
        console.log('Service worker has been registered.')
      },
      cached() {
        console.log('Content has been cached for offline use.')
      },
      updatefound() {
        console.log('New content is downloading.')
      },
      updated() {
        console.log('New content is available; please refresh.')
        // Optionnel: Afficher une notification pour mettre à jour
        if (window.confirm('Une nouvelle version est disponible. Voulez-vous recharger la page ?')) {
          window.location.reload()
        }
      },
      offline() {
        console.log('No internet connection found. App is running in offline mode.')
      },
      error(error: any) {
        console.error('Error during service worker registration:', error)
      }
    });
  }).catch((err) => {
    console.warn('Service worker registration skipped:', err);
  });
}

